export function parseStringListFromConfigValue(value: string | boolean) {
  const configValue = value as string;
  if (configValue === undefined || configValue === null || configValue.trim() === '') {
    return [];
  }

  try {
    return JSON.parse(configValue) as string[];
  } catch (e) {
    return [];
  }
}
